import burger_nav from './burger_nav'
import main_nav from './main_nav'


/**
 * Initialisation globale de la navigation
 */
function init(){
    // console.log("Initialisation de la navigation");
    main_nav();
    burger_nav();
}


export {init};